<template>
  <v-btn
    class="mbtn font-weight-regular"
    prepend-icon="ct:arrow-left"
    @click="appraisalBuyoutStep -= buyoutStore.hideMetaMasterStep ? 2 : 1"
  >
    {{ t("buyout.appraisal.go_back") }}
  </v-btn>
  <div :class="`app__title app__title--h3 app__title--${selectedDeviceType?.seo_name}`">
    {{ `${ authStore.isPartner ? t("buyout.appraisal.state_customers") : t("buyout.appraisal.state_yours")} ${selectedProductColor?.name} ${isNewDeviceProcess ? t("static.banners.for_buyout") : ''}` }}
  </div>
  <div class="buyout__detail">
    <img :src="buildImageUrl(selectedProductColor?.image ? selectedProductColor.image : '')" class="img-responsive">
    <div class="wrapper">
      <div
        v-if="selectedDeviceType"
        class="d-flex justify-space-between align-center mb-2"
      >
        <span :class="['flex-fill', 'app__label', 'mb-0', !selectedQualityError ? 'color--grayTone3' : 'color--redTone2', selectedProductQuality ? 'is-checked': '']">
          {{ `${t("buyout.appraisal.choose_state")} ${getTranslation} ${selectedDeviceType.name_second_case}` }}
        </span>
        <v-dialog
          v-model="showAppraisalVideo"
          :class="dialogVideoClass"
        >
          <template #activator="{ props }">
            <v-btn
              v-if="lgAndUp"
              class="mbtn mbtn--blue mbtn--play"
              size="small"
              prepend-icon="ct:play"
              v-bind="props"
            >
              {{ t("buyout.appraisal.how_to") }}
            </v-btn>
            <v-btn
              v-else
              class="color--blueTone1"
              size="x-small"
              icon="ct:play-solid"
              v-bind="props"
            />
          </template>
          <div
            class="popup__close cursor-pointer"
            @click="showAppraisalVideo = false"
          >
            <v-icon icon="ct:cross" size="x-small" />
          </div>
          <videos-the-video :video-url="appraisalVideo" :mark-as-viewed="false" :auto-play="true" @set-video-class="setDialogClass" />
        </v-dialog>
      </div>
      <v-progress-circular v-if="loadingAvailableProductAppraisal" />
      <client-only v-else>
        <div id="qualitiesDiv" :class="['worth', selectedProductQuality ? 'is-selected': '']">
          <div
            v-for="item in availableDeviceQualities"
            :key="item.id"
            :class="`worth__item worth__item--${item.quality.short_name} ${item.id === selectedProductQuality?.id ? 'is-selected': ''} cursor-pointer`"
            @click="selectQuality(item)"
          >
            <div class="worth__state">
              <div
                class="worth__headline font-weight-semibold first-letter-uppercase"
                v-html="`${item.quality.name}`"
              />
              <v-icon
                :class="`icon worth__stars icon--${item.quality.short_name}`"
                :icon="`ct:stars-${item.quality.short_name}`"
              />
            </div>
            <div class="worth__price font-weight-semibold">
              {{ useCurrency(item.buying_price) }}
            </div>
            <v-list>
              <v-list-item
                v-for="(listItem, index) in qualityListToArray(item.quality.long_description)"
                :key="index"
                :title="listItem"
              />
            </v-list>
            <v-btn
              v-if="item.device_3d_model_path"
              :href="item.device_3d_model_path"
              target="_blank"
              class="mbtn mbtn--trans mbtn--3d color--grayTone3 mt-4 justify-self-start"
              size="small"
              prepend-icon="ct:cube"
            >
              {{ t("buyout.appraisal.display_3d_model") }}
            </v-btn>
            <v-btn
              v-if="mdAndDown"
              class="mbtn mbtn--green"
              size="large"
              max-width="130"
            >
              {{ t('buyout.detail.select') }}
            </v-btn>
          </div>
        </div>
        <v-alert v-if="selectedQualityError && false" class="vAlert--info">
          <template #title>
            {{ t("buyout.appraisal.need_help_with_appraisal") }}
          </template>
          <v-btn
            class="mbtn mbtn--blue"
            size="large"
            prepend-icon="ct:play"
          >
            {{ t("buyout.appraisal.play_instructions_video") }}
          </v-btn>
        </v-alert>
        <template v-if="lgAndUp || selectedProductQuality">
          <v-form
            id="qualityForm"
            ref="form"
            v-model="qualityFormValid"
            class="app__form"
          >
            <div class="formItem formItem--1x12">
              <v-text-field
                v-if="selectedDeviceType && selectedDeviceType.requires_imei"
                v-model="buyoutDeviceImei"
                :label="t('buyout.appraisal.buyout_device_imei')"
                :placeholder="t('buyout.appraisal.imei_hint')"
                :rules="imeiRules"
                :error-messages="imeiErrors"
                type="text"
                @input="imeiErrors = []"
              />
              <v-text-field
                v-else
                id="imei"
                v-model="buyoutDeviceImei"
                :label="t('buyout.appraisal.buyout_device_sn')"
                :rules="[rules.required]"
                :error-messages="imeiErrors"
                @input="imeiErrors = []"
              />
            </div>
            <v-progress-circular v-if="accessoriesLoading" />
            <div
              v-for="accessory in accessories"
              :key="accessory.id"
              class="formItem formItem--1x12 formItem--noLabel"
            >
              <v-text-field
                v-model="accessory.quantity"
                :label="accessory.fe_description"
                type="number"
                min="0"
                :max="runtimeConfig.public.maxControllersQuantity"
                :rules="[rules.required, rules.minValue(0), rules.maxValue(runtimeConfig.public.maxControllersQuantity as number)]"
              >
                <template #append-inner>
                  <v-tooltip
                    v-if="accessory.fe_hint"
                    class="vTooltip--buyout"
                    location="top"
                    :open-on-click="true"
                    :close-on-content-click="true"
                    :close-delay="200"
                  >
                    <template #activator="{ props }">
                      <v-btn
                        icon
                        v-bind="props"
                      >
                        <v-icon class="color--blueTone1" :icon="mdiInformation" />
                      </v-btn>
                    </template>
                    <div class="vTooltip__desc">
                      {{ accessory.fe_hint }}
                    </div>
                  </v-tooltip>
                </template>
              </v-text-field>
              <span
                v-if="accessory?.quantity && (accessory.quantity * accessory.price) > 0"
                class="text-right price color--greenTone1 font-weight-semibold"
              >
                +{{ useCurrency(accessory.quantity * accessory.price) }}
              </span>
            </div>
            <div class="vRadioGroup formItem formItem--1x12 formItem--noLabel">
              <v-progress-circular v-if="defectsLoading" />
              <v-radio-group
                v-for="defect in defectsAnswers"
                v-else
                :key="defect.id"
                :rules="[rules.required]"
                :model-value="defect.selectedValue"
                :inline="true"
              >
                <div class="app__label color--grayTone3">
                  {{ defect.description }}
                </div>
                <v-radio
                  v-for="defect_value in defect.defect_values"
                  :key="defect_value.id"
                  :label="defect_value.label"
                  :value="defect_value"
                  @input="checkQualityChange(defect_value, defect)"
                />
                <div
                  v-if="defect.selectedValue && defect.selectedValue.value > 0"
                  class="price color--redTone2 font-weight-semibold"
                >
                  - {{ useCurrency(defect.selectedValue.value) }}
                </div>
                <div v-else-if="defect.selectedValue && defect.selectedValue.disable_buyout" class="color--redTone2 font-weight-semibold">
                  {{ t('buyout.appraisal.disabled_buyout') }}
                </div>
              </v-radio-group>
            </div>
            <div v-if="accessoriesErrors && accessoriesErrors.length > 0" class="formItem formItem--1x12 formItem--noLabel app__label color--redTone2">
              {{ accessoriesErrors }}
            </div>
          </v-form>
          <div class="app__form app__form--small">
            <div
              v-if="checksError"
              class="formItem formItem--1x12 formItem--noLabel app__label color--redTone2"
            >
              {{ t('buyout.appraisal.check_all_fields') }}
            </div>
            <div
              v-for="check in checks"
              id="qualityChecks"
              :key="check.identifier"
              class="formItem formItem--1x12 formItem--checkbox formItem--noLabel"
            >
              <v-checkbox
                v-model="selectedChecks"
                :multiple="true"
                :label="check.description_fe"
                :rules="[rules.required]"
                :value="check.identifier"
                required
              >
                <template #append>
                  <v-dialog
                    v-if="check?.hint && check.hint.video_url"
                    v-model="checkDialogs[check.id]"
                    :class="dialogVideoClass"
                  >
                    <template #activator="{ props }">
                      <v-btn
                        v-if="lgAndUp"
                        class="mbtn mbtn--blue mbtn--play"
                        size="small"
                        prepend-icon="ct:play"
                        v-bind="props"
                      >
                        {{ t("buyout.appraisal.instructions") }}
                      </v-btn>
                      <v-btn
                        v-else
                        class="color--blueTone1"
                        size="x-small"
                        icon="ct:play-solid"
                        v-bind="props"
                      />
                    </template>
                    <div
                      class="popup__close cursor-pointer"
                      @click="checkDialog(check.id)"
                    >
                      <v-icon icon="ct:cross" size="x-small" />
                    </div>
                    <videos-the-video v-if="check?.hint && check.hint.video_url" :video-url="check.hint.video_url" :mark-as-viewed="false" :auto-play="true" @set-video-class="setDialogClass" />
                  </v-dialog>
                  <v-tooltip
                    v-else-if="check?.hint && check.hint.tooltip_fe"
                    class="vTooltip--buyout"
                    location="top"
                    :open-on-click="true"
                    :close-on-content-click="true"
                    :close-delay="200"
                  >
                    <template #activator="{ props }">
                      <v-btn
                        class="mr-n1"
                        size="small"
                        icon
                        v-bind="props"
                      >
                        <v-icon class="color--blueTone1" :icon="mdiInformation" />
                      </v-btn>
                    </template>
                    <div class="vTooltip__desc" v-html="check.hint.tooltip_fe.replace('**contact_url**', contactUrl)" />
                  </v-tooltip>
                </template>
              </v-checkbox>
            </div>
          </div>
          <v-btn
            v-if="!authStore.isPartner || authStore.isPartnerBrandStore || (authStore.isPartner && authStore?.data?.partner?.has_buyout_bonuses && buyoutStore.bonusesForSelectedQuality) || (authStore.isPartner && isNewDeviceProcess)"
            class="mbtn mbtn--green"
            size="x-large"
            :disabled="disabledBuyout"
            :loading="moveToBonusStepLoading || partnerDeviceBonusCheckLoading"
            @click="moveToBonusStep"
          >
            {{ t('buyout.appraisal.continue') }}
          </v-btn>
        </template>
      </client-only>
      <buyout-send-email-window v-if="!isNewDeviceProcess" :disable-send="disabledBuyout" :move-to-bonus-step-fn="moveToBonusStep" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useDisplay } from "vuetify";
import { VForm } from "vuetify/components";
import useCurrency from "cashtec-common/src/composables/useCurrency";
import { mdiInformation } from "@mdi/js";

const { mdAndDown, lgAndUp } = useDisplay();
const { rules } = useFormValidators();
const { buildImageUrl } = useUtils();
const buyoutStore = useBuyoutStore();
const partnerStore = usePartnerStore();
const authStore = useAuthStore();
const { t, locale } = useI18n();
const api = useApi();
const { notify } = useNotification();
const localePath = useLocalePath();
const route = useRoute();
const runtimeConfig = useRuntimeConfig();

const form = ref<VForm | null>(null);
const checksLoading = ref<boolean>(false);
const checkDialogs = ref<Record<string, boolean>>({});
const qualityFormValid = ref<boolean>(false);
const imeiErrors = ref<string[]>([]);
const selectedQualityError = ref<boolean>(false);
const accessoriesErrors = ref<string[]>([]);
const checksError = ref<boolean>(false);
const lastSelectedProductQuality = ref<BuyoutProductQuality | null>(null);
const moveToBonusStepLoading = ref<boolean>(false);
const dialogVideoClass = ref<string>("embedVideo--360");
const showAppraisalVideo = ref(false);
const partnerDeviceBonusCheckLoading = ref(false);
const bonuses = ref(false);
const bonusPartnerWithManufacturerBuyoutStore = useBonusPartnerWithManufacturerBuyoutStore();

const componentProps = withDefaults(defineProps<{
  isNewDeviceProcess?: boolean
}>(), {
  isNewDeviceProcess: false
});

const contactUrl = computed<string>(() => {
  const contactPathName = route.params.partner || (authStore.isLoggedIn && authStore.data?.partner) ? "partner-contact" : "contact";
  return `${runtimeConfig.app.baseURL}${localePath({ name: contactPathName, params: { partner: (route.params.partner as string) ?? authStore.data?.partner?.seo_name } })}`;
});

const appraisalVideo = computed<string>(() => {
  const videoUrls: Record<string, string> = {
    "cs": "https://vimeo.com/1011218985?share=copy",
    "en": "https://vimeo.com/1011220979?share=copy"
  };

  return videoUrls[locale.value] || videoUrls["cs"];
});

const {
  selectedProductQuality,
  selectedProductColor,
  appraisalBuyoutStep,
  buyoutDeviceImei,
  selectedDeviceType,
  availableDeviceQualities,
  accessories,
  mainBuyoutStep,
  loadingAvailableProductAppraisal,
  userBuyoutCode,
  defectsAnswers,
  defectsLoading,
  accessoriesLoading,
  selectedChecks,
  checks,
  takeStep
} = storeToRefs(buyoutStore);

if (!availableDeviceQualities?.value?.length || !(availableDeviceQualities.value.length > 0)) {
  buyoutStore.loadAvailableProductAppraisal();
}

useMoveToTopOfPage();

const imeiRules = computed(() => {
  return selectedDeviceType.value?.requires_imei ? [rules.required, rules.isIMEIValid] : [rules.required];
});

const allChecksSelected = computed<boolean>(() => {
  return selectedChecks.value?.length === checks.value?.length;
});

const disabledBuyout = computed<boolean>(() => {
  return defectsAnswers.value.some(answer => answer?.selectedValue && answer.selectedValue.disable_buyout);
});

async function validateData () {
  selectedQualityError.value = !selectedProductQuality?.value;
  const formValid = await form!.value!.validate();
  checksError.value = !allChecksSelected.value;

  return !selectedQualityError.value && !checksError.value && formValid.valid;
}

function setDialogClass (videoSize: {height: number, width: number}) {
  dialogVideoClass.value = videoSize.height > videoSize.width ? "embedVideo--360" : "embedVideo--1200";
}

function checkDialog (checkId: string) {
  checkDialogs.value[checkId] = false;
}

async function hasPartnerBonusesForDevice() {
  if (authStore.isPartner && authStore?.data?.partner?.id && selectedProductQuality.value?.id) {
    const { data } = await api.call<{ has_buyout_bonuses: boolean }>(api.commonUrls.buyout.HAS_PARTNER_DEVICE_BONUSES(selectedProductQuality.value?.id));
    if (data.value) {
      if (data.value) {
        buyoutStore.bonusesForSelectedQuality = data.value?.has_buyout_bonuses;
      }
    }
  }
}

// to check if the selected quality have available bonuse
watch(() => selectedProductQuality.value?.id, async (newValue) => {
  if (newValue) {
    partnerDeviceBonusCheckLoading.value = true;
    await hasPartnerBonusesForDevice();
    partnerDeviceBonusCheckLoading.value = false;
  }
});

async function moveToBonusStep () {
  moveToBonusStepLoading.value = true;
  let erScrollEl = "#qualityChecks";
  if (!await validateData()) {
    if (selectedQualityError.value) {

      erScrollEl = "#qualitiesDiv";
    } else if (!qualityFormValid.value) {
      erScrollEl = "#qualityForm";
    }
    await useGoTo(erScrollEl, { offset: -200 });
    moveToBonusStepLoading.value = false;

    return;
  }

  const { data, error } = await api.call<{ registration_number: string, available_bonus_partners: PartnerBonus[] }>(api.commonUrls.buyout.CREATE_DEVICE_IMEI(), {
    method: "POST",
    body: {
      device_id: selectedProductQuality.value!.id,
      old_device_imei: buyoutDeviceImei!.value,
      customer_id: buyoutStore.getBuyoutCustomerId(),
      registration_number: userBuyoutCode?.value,
      price: selectedProductQuality.value!.buying_price,
      defects_answers: defectsAnswers.value.map(answer => (answer.selectedValue!.id)),
      referral_id: buyoutStore.getBuyoutReferralId(),
      referral_link_id: buyoutStore.buyoutReferralLinkId,
      accessories: buyoutStore.accessories
    }
  });
  if (data.value) {
    userBuyoutCode.value = data.value?.registration_number;
    if (takeStep.value) {
      window.history.pushState({}, "", `${window.location.pathname}?userBuyoutCode=${userBuyoutCode.value}`);
      if(componentProps.isNewDeviceProcess) {
        buyoutStore.appraisalBuyoutStep += 1;
        await bonusPartnerWithManufacturerBuyoutStore.loadBuyoutBonuses();
        moveToBonusStepLoading.value = false;
        return;
      }
      window.history.pushState({}, "", `${window.location.pathname}?userBuyoutCode=${userBuyoutCode.value}`);
      if(componentProps.isNewDeviceProcess) {
        buyoutStore.appraisalBuyoutStep += 1;
        await bonusPartnerWithManufacturerBuyoutStore.loadBuyoutBonuses();
        moveToBonusStepLoading.value = false;
        return;
      }
      // Handle bonuses
      resetBonuses();
      await buyoutStore.loadAvailableBonusPartners(data.value?.available_bonus_partners);
      // 1 because of "other" partner
      if (!(buyoutStore.availableBonusPartners.length > 1)) {
        buyoutStore.bonusesForSelectedQuality = false;
        bonuses.value = false;
      }
      if (partnerStore?.getBuyoutPartner) {
        buyoutStore.selectedBonusPartner = buyoutStore.availableBonusPartners.find(partner => partner.id === partnerStore!.getBuyoutPartner!.id) || null;
        await buyoutStore.loadAvailableNewMetaMasters();
        if (!(buyoutStore.availableNewMetaMasters.length > 0)) {
          buyoutStore.bonusesForSelectedQuality = false;
          bonuses.value = false;
        }
      }
      if (bonuses.value) {
        buyoutStore.bonusesForSelectedQuality = true;
      }
      mainBuyoutStep.value += buyoutStore.showBonuses ? 1 : 2;
    }
  }
  if (error.value) {
    if (error.value!.data && "old_device_imei" in error.value.data) {
      imeiErrors.value = error.value!.data!.old_device_imei as string[];
    } else if (error.value!.data && "accessories" in error.value.data) {
      accessoriesErrors.value = error.value!.data!.accessories as string[];
    } else {
      notify({
        title: t("form.common.error"),
        text: t("general.error_sending_request"),
        type: "error"
      });
    }
  }
  moveToBonusStepLoading.value = false;
}

function resetBonuses () {
  buyoutStore.selectedBonusPartner = null;
  buyoutStore.availableNewMetaMasters = [];
  buyoutStore.selectedNewMetaMaster = null;
  buyoutStore.availableNewProductColors = [];
  buyoutStore.selectedBuyoutBonuses = [];
  buyoutStore.selectedNewProductVariant = null;
  buyoutStore.selectedNewProductColor = null;
  buyoutStore.availableNewProductVariants = null;
}

if (!defectsAnswers?.value?.length) {
  buyoutStore.loadDefects();
}

if (!accessories?.value?.length) {
  buyoutStore.loadAccessories();
}

if (!selectedChecks?.value?.length) {
  await loadChecks();
  if (userBuyoutCode.value) {
    if(buyoutStore.firstChecksCheck && componentProps.isNewDeviceProcess){
      buyoutStore.firstChecksCheck = false;
    } else {
      selectedChecks.value = checks.value.map(ch => ch.identifier);
    }
  }
}

// To do Check this, done very fast
async function checkQualityChange (defectValue: BuyoutDefectValue, defect: EnhancedBuyoutDefect) {
  let change = false;
  if (defect?.selectedValue?.change_to_quality?.id && !defectValue.change_to_quality?.id) {
    change = true;
  }
  defect.selectedValue = defectValue;
  const defectWithQualityChange = defectsAnswers.value.filter(da => da.selectedValue !== null).find(da => da!.selectedValue!.change_to_quality !== null);
  if (change && lastSelectedProductQuality.value && !(defectWithQualityChange)) {
    selectedProductQuality.value = lastSelectedProductQuality.value;
  } else if (defectWithQualityChange) {
    await selectQuality(availableDeviceQualities.value.find(dq => dq.quality.id === defectValue.change_to_quality!.id) || null, false);
  }
  if (defectValue?.change_to_quality?.id) {
    await selectQuality(availableDeviceQualities.value.find(dq => dq.quality.id === defectValue.change_to_quality!.id) || null, false);
    useGoTo("#qualitiesDiv", { offset: -200 });
  }
}

async function loadChecks () {
  checksLoading.value = true;
  if (!selectedProductColor.value) {
    notify({
      title: t("form.common.error"),
      text: t("general.no_data"),
      type: "error"
    });
    checksLoading.value = false;
    return;
  }
  const { data, error } = await api.call<TypeBuyoutCheck[]>(api.commonUrls.buyout.TYPE_BUYOUT_CHECKS(selectedProductColor.value!.id));
  if (data.value) {
    checkDialogs.value = {};
    checks.value = data.value;
  }
  if (error.value) {
    notify({
      title: t("form.common.error"),
      text: t("general.error_sending_request"),
      type: "error"
    });
  }
  checksLoading.value = false;
}

const getTranslation = computed<string>(() => {
  if (selectedDeviceType.value && selectedDeviceType.value.seo_name === "gaming") {
    return t("buyout.appraisal.buyout_case_console");
  }
  if (selectedDeviceType.value && selectedDeviceType.value.seo_name === "chytre-hodinky") {
    return t("buyout.appraisal.buyout_case_watches");
  }

  return t("buyout.appraisal.buyout_case_ptn");
});

async function selectQuality (quality: BuyoutProductQuality | null, userChange = true) {
  // To do Check this, done very fast
  if (defectsAnswers.value.filter(da => da.selectedValue !== null).find(da => da!.selectedValue!.change_to_quality !== null) && userChange) {
    defectsAnswers.value.forEach(function (da) {
      da.selectedValue = null;
    });
  }
  if (selectedProductQuality.value !== quality) {
    selectedQualityError.value = false;
    lastSelectedProductQuality.value = selectedProductQuality.value;
    selectedProductQuality.value = quality;
    await buyoutStore.changeURL();
    if(componentProps.isNewDeviceProcess){
      await bonusPartnerWithManufacturerBuyoutStore.changeURLNewDevice();
    } else { await buyoutStore.changeURL(); };

    nextTick(() => {
      if (document.querySelector("#imei")) {
        useGoTo("#imei", { offset: -100 });
      }
    });
  }
}
function qualityListToArray (list: string) {
  return Array.from(new DOMParser().parseFromString(list, "text/html").querySelectorAll("li")).map(li => li?.textContent?.trim());
}

watch(selectedChecks, () => {
  checksError.value = false;
});

</script>
